import { render } from "./MultiselectItem.vue?vue&type=template&id=a21ff462&scoped=true"
import script from "./MultiselectItem.vue?vue&type=script&lang=js"
export * from "./MultiselectItem.vue?vue&type=script&lang=js"

import "./MultiselectItem.vue?vue&type=style&index=0&id=a21ff462&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21ff462"]])

export default __exports__